import api from '../../api';
import { ICommissionBreakdownObject } from '../../data/entities/commission-breakdown';
import { ActionTypeNames, ActionValues, createActionCreators } from '../../store/actions';
import { ThunkAction } from '../../store/middleware';
import { idOrLegacyId } from '../properties/selectors';

export const getCommissionBreakdownActions = createActionCreators<
	{ T: 'COMMISSION_BREAKDOWN_GET_BY_PROP_CHANNEL_ID_REQUEST', P: { propertyId: string, channelIds: string[] } },
	{
		T: 'COMMISSION_BREAKDOWN_GET_BY_PROP_CHANNEL_ID_RECEIVE', P: {
			propertyId: string,
			channelIds: string[],
			commissionBreakdown: ICommissionBreakdownObject
		}
	},
	{ T: 'COMMISSION_BREAKDOWN_GET_BY_PROP_CHANNEL_ID_FAILURE', P: { error: Error } }
>('COMMISSION_BREAKDOWN_GET_BY_PROP_CHANNEL_ID_REQUEST', 'COMMISSION_BREAKDOWN_GET_BY_PROP_CHANNEL_ID_RECEIVE', 'COMMISSION_BREAKDOWN_GET_BY_PROP_CHANNEL_ID_FAILURE');

export const getCommissionBreakdown = (id: string | number, channelIds: string[]):
	ThunkAction<any> => async (dispatch, getState) => {
		const propertyId = idOrLegacyId(id);
		dispatch(getCommissionBreakdownActions.COMMISSION_BREAKDOWN_GET_BY_PROP_CHANNEL_ID_REQUEST({ propertyId, channelIds }));
		try {
			const commissionBreakdown = await api.commission.getBookingBreakdown(propertyId, channelIds);
			dispatch(getCommissionBreakdownActions.COMMISSION_BREAKDOWN_GET_BY_PROP_CHANNEL_ID_RECEIVE({ propertyId, channelIds, commissionBreakdown }));
		} catch (error) {
			dispatch(getCommissionBreakdownActions.COMMISSION_BREAKDOWN_GET_BY_PROP_CHANNEL_ID_FAILURE({ error }));
			throw error;
		}
	};

const actions = {
	...getCommissionBreakdownActions,
};

type commissionBreakdownActions = ActionValues<typeof actions>;
type commissionBreakdownActionTypes = ActionTypeNames<commissionBreakdownActions>;
export type Actions = commissionBreakdownActions[keyof commissionBreakdownActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as commissionBreakdownActionTypes);
